import React, { Props } from 'react';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            height: 'auto',
            overflow: 'hidden',
        },
    }),
);

export const FullscreenLayout = (props: Props<any>) => {
    const classes = useStyles();
    return <div className={classes.root}>{props.children}</div>;
};
